var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"content-topic-component"},[_c('div',{staticClass:"overflow-y-scroll hundo-height",attrs:{"id":"single-col-topic"}},[_c('markdown-renderer'),_c('submit-button')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }